import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { ListPlansResponse } from './plans.types'

const listPlans = async (): Promise<ListPlansResponse> => {
  const response = await apiClient.get<ListPlansResponse>('/v1/billing/plans')
  return response.data
}

export const useListPlans = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: ['billing-plans'],
    queryFn: listPlans,
    enabled: options?.enabled,
  })
}
